import { createFileRoute, redirect } from '@tanstack/react-router';

// A bare geoset resolves to its geofences view.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/geosets/$geosetId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/geosets/$geosetId/geofences',
      params: { workspaceId: params.workspaceId, geosetId: params.geosetId },
      replace: true,
    });
  },
});
